export default __webpack_public_path__ + "public/assets/images/ed0faa1ceb074b2b273f92285d80f90e.jpg";